import { BaseEntityDto } from '../common/base-entity.dto';
import { UserRole } from '../../enums';

export interface AdminProfileDto extends BaseEntityDto {
  userId: string; // Guid
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  role: UserRole;
  department?: string | null;
  jobTitle?: string | null;
  isActive: boolean;
  lastLoginDate?: string | null; // DateTime as ISO string
}
